export default "__VITE_ASSET__8bc67d0f__"